/**
 * @typedef {import ('../interfaces/services/IFormularDenuncia.interface').IFormularDenunciaForm} IFormularDenunciaForm
 * @typedef {import ('../interfaces/utils/axios.interface').IProcessedData<IFormularDenunciaForm>} IProcessedPostFormularDenuncia
 */

import {
  callDeleteExternalApi,
  callGetExternalApi,
  callPostExternalApi,
  callPutExternalApi,
} from '../utils/externalApiCall';

// @ts-ignore
const baseURL = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_BASE_CONTEXT_SII}`;

/**
 * Listado de rutas del backend
 *
 * @param {Object} param
 * @return {Object.<string,string>}
 */
const getBackendUrl = ({ id, idAuthority, status } = {}) => ({
  GET_COMPLAINT_LIST: `${baseURL}/private/complaint`,
  GET_COMPLAINT_MESSAGES: `${baseURL}/private/complaint/${id}/message`,
  GET_COMPLAINT: `${baseURL}/private/complaint/${id}`,
  GET_COMPLAINT_SECURE: `${baseURL}/private/complaint/pub/${id}`, // publicId
  POST_COMPLAINT: `${baseURL}/public/complaint/`,
  PUT_ASSIGN_USER: `${baseURL}/private/complaint/${id}/authority/${idAuthority}`,
  DELETE_UNASSIGN_USER: `${baseURL}/private/complaint/${id}/authority/${idAuthority}/unassign`,
  GET_AUTORIDADES: `${baseURL}/private/complaint/${id}/authority`,
  PUT_STATUS: `${baseURL}/private/complaint/${id}/status/${status}`,
  GET_COMPLAINTS_ASSIGNED: `${baseURL}/private/complaint/user/${idAuthority}`,
  DELETE_UNASSING_COMPLAINT: `${baseURL}/private/complaint/${id}/authority/${idAuthority}/unassign`,
});

/**
 * @returns {Promise<*>}
 */
const getDenuncias = async () => callGetExternalApi({ url: getBackendUrl().GET_COMPLAINT_LIST });

/**
 * @returns {Promise<*>}
 */
const getDetalleDenuncia = async ({ id }) => callGetExternalApi({ url: getBackendUrl({ id }).GET_COMPLAINT });

/**
 * @returns {Promise<*>}
 */
const getDetalleDenunciaSecure = async ({ id }) =>
  callGetExternalApi({ url: getBackendUrl({ id }).GET_COMPLAINT_SECURE });

/**
 * @returns {Promise<*>}
 */
const getMensajesDenuncia = async ({ id }) => callGetExternalApi({ url: getBackendUrl({ id }).GET_COMPLAINT_MESSAGES });

/**
 * @returns {Promise<IProcessedPostFormularDenuncia>}
 */
const postFormularDenuncia = async ({ data }) => callPostExternalApi({ url: getBackendUrl().POST_COMPLAINT, data });

/**
 * @returns {Promise<*>}
 */
const postMensajesDenuncia = async ({ id, data }) =>
  callPostExternalApi({ url: getBackendUrl({ id }).GET_COMPLAINT_MESSAGES, data });

/**
 * @returns {Promise<*>}
 */
const putAsignarUsuario = async ({ id, idAuthority }) =>
  callPutExternalApi({ url: getBackendUrl({ id, idAuthority }).PUT_ASSIGN_USER });

/**
 * @returns {Promise<*>}
 */
const deleteDesasignarUsuario = async ({ id, idAuthority }) =>
  callDeleteExternalApi({ url: getBackendUrl({ id, idAuthority }).DELETE_UNASSIGN_USER });

/**
 * @returns {Promise<*>}
 */
const deleteUnssignComplaint = async ({ id, idAuthority }) =>
  callDeleteExternalApi({ url: getBackendUrl({ id, idAuthority }).DELETE_UNASSING_COMPLAINT });

/**
 * @returns {Promise<*>}
 */
const putStatus = async ({ id, status }) => callPutExternalApi({ url: getBackendUrl({ id, status }).PUT_STATUS });

/**
 * @returns {Promise<*>}
 */
const getAutoridades = async ({ id }) => callGetExternalApi({ url: getBackendUrl({ id }).GET_AUTORIDADES });

/**
 * @returns {Promise<*>}
 */
const getComplaintsAssigned = async ({ idAuthority }) =>
  callGetExternalApi({ url: getBackendUrl({ idAuthority }).GET_COMPLAINTS_ASSIGNED });

export {
  getDenuncias,
  getDetalleDenuncia,
  getDetalleDenunciaSecure,
  getMensajesDenuncia,
  postMensajesDenuncia,
  putAsignarUsuario,
  deleteDesasignarUsuario,
  postFormularDenuncia,
  getAutoridades,
  putStatus,
  getComplaintsAssigned,
  deleteUnssignComplaint,
};
